var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.windowWidth > _vm.tabletDisplayPixels
    ? _c(
        "div",
        { ref: "bg", staticClass: "landing-background", attrs: { id: "bg" } },
        [
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.hovered
              ? _c(
                  "video",
                  {
                    key: _vm.videoUrl,
                    attrs: {
                      autoplay: "",
                      muted: "",
                      loop: "",
                      id: "backgroundVideo"
                    },
                    domProps: { muted: true }
                  },
                  [
                    _c("source", {
                      ref: "backgroundVideoSource",
                      attrs: { src: _vm.videoUrl, type: "video/mp4" }
                    })
                  ]
                )
              : _vm._e()
          ]),
          _c(
            "div",
            {
              staticClass: "left-div",
              on: {
                mouseenter: function($event) {
                  return _vm.setBgVideo(_vm.sides.left)
                },
                mouseleave: function($event) {
                  return _vm.setBgVideo()
                },
                click: function($event) {
                  return _vm.redirectToDrc()
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "landing-content" },
                [
                  _c("h1", [_vm._v("Digital Reference Catalogue")]),
                  _c("div", { staticClass: "landing-text" }, [
                    _vm._v(_vm._s(_vm.$t("landingPage.drcDescription")) + " ")
                  ]),
                  _c("transition", { attrs: { name: "fade" } }, [
                    _vm.hovered === _vm.sides.left
                      ? _c("button", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("landingPage.exploreDrc").toUpperCase()
                            ) + " "
                          )
                        ])
                      : _vm._e()
                  ])
                ],
                1
              )
            ]
          ),
          _c("div", { staticClass: "divider" }),
          _c(
            "div",
            {
              staticClass: "right-div",
              on: {
                mouseenter: function($event) {
                  return _vm.setBgVideo(_vm.sides.right)
                },
                mouseleave: function($event) {
                  return _vm.setBgVideo()
                },
                click: function($event) {
                  return _vm.redirectToGop()
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "landing-content" },
                [
                  _c("h1", [_vm._v("Group Offer Portfolio")]),
                  _c("div", { staticClass: "landing-text" }, [
                    _vm._v(_vm._s(_vm.$t("landingPage.gopDescription")) + " ")
                  ]),
                  _c("transition", { attrs: { name: "fade" } }, [
                    _vm.hovered === _vm.sides.right
                      ? _c("button", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("landingPage.exploreGop").toUpperCase()
                            )
                          )
                        ])
                      : _vm._e()
                  ])
                ],
                1
              )
            ]
          ),
          _c("Newsletter"),
          _c("div", { staticClass: "landing-backdrop" })
        ],
        1
      )
    : _c("div", [_c("MobileLanding")], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }